<template>
    <div ref="pdfWrapper" class="file-wrapper-pdf">
        <Pdf v-if="pdf" class="file-wrapper-pdf-content" />
        <PtNodata v-else class="file-wrapper-pdf-nodata" :nodataTips="nodataTips" />
    </div>
</template>

<script setup lang="ts">
import ResizeObserver from 'resize-observer-polyfill';
import { defineProps, onMounted, ref, onUnmounted, nextTick, watch } from 'vue';
import Pdf from './Pdf';
import PtNodata from '../PtNodata';

const props = defineProps({
    pdf: {
        type: String,
        default: '',
    },
    nodataTips: {
        type: String,
        default: '',
    },
});
const observer = ref(null);
const pdfWrapper = ref(null);

const resetPdf = () => {
    const iframe = pdfWrapper.value?.querySelector('iframe');
    if (iframe) {
        iframe.src = props.pdf;
    }
};

onMounted(async () => {
    await nextTick();
    observer.value = new ResizeObserver(resetPdf);
    observer.value.observe(pdfWrapper.value);
});

onUnmounted(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});

watch(
    () => props.pdf,
    () => {
        resetPdf();
    },
);

</script>

<style lang="scss">
.file-wrapper-pdf {
    height: 100%;
    .file-wrapper-pdf-content {
        height: 100%;
    }

    .file-wrapper-pdf-nodata {
        margin-top: 64px;
        .pt_nodata-title {
            color: $text-hint;
            font-size: 14px;
        }
    }
}
</style>
